module.exports = __webpack_public_path__ + "static/img/designReviewManage.79078814.png";